<template>
	<component :is="configType" :tableData="tableData">
    <infinite-loading dataProp="params" :onRequestData="onRequestData" ref="infinite" :distance="10" force-wrapper=".el-table__body-wrapper" :parent-dom="currentParentDom">
    </infinite-loading>
  </component>
</template>
<script>
/**
 * 产品新建/编辑页面
 */
import infiniteLoading from 'cps/base/infinite-loading'
import RISK from './tables/RISK'
import LH from './tables/LH'
import CAUSAL from './tables/CAUSAL'
import CAUSAL_AUTO from './tables/CAUSAL_AUTO'
import MT_HAPLO_TYPE from './tables/MT_HAPLO_TYPE'
import Y_HAPLO_TYPE from './tables/Y_HAPLO_TYPE'
import NEANDERTHAL from './tables/NEANDERTHAL'
import ANCESTRY_COMPOSITION from './tables/ANCESTRY_COMPOSITION'

const needInfiniteTypes = ['RISK', 'CAUSAL', 'CAUSAL_AUTO']
export default {
  name: 'data-entry-form',
  components: {
    RISK,
    LH,
    CAUSAL,
    CAUSAL_AUTO,
    infiniteLoading,
    MT_HAPLO_TYPE,
    Y_HAPLO_TYPE,
    NEANDERTHAL,
    ANCESTRY_COMPOSITION
  },
  props: {
    configType: {
      type: String,
      default: ''
    },
    configId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  watch: {
    configId (val) {
      this.tableData = []
      if (val && this.configType) {
        if (this.NotNeedInfinite) {
          this.onRequestData(0)
          setTimeout(_ => {
            this.$refs.infinite.reset()
          }, 0)
        }
      }
    }
  },
  computed: {
    currentParentDom () {
      return `.infinite-table-${this.configType}`
    },
    NotNeedInfinite () {
      return !needInfiniteTypes.includes(this.configType)
    }
  },
  methods: {
    buildFilterParams (page) {
      return {
        id: this.configId,
        page: page,
        size: 20
      }
    },
    onRequestData (page, next) {
      let data = this.buildFilterParams(page)
      this.$store.dispatch('getDetectionConfigParams', data).then(res => {
        if (!this.NotNeedInfinite) {
          if (next) {
            next(res.data)
          }
        }
        if (res.data.params.length) {
          this.tableData = this.tableData.concat(res.data.params)
        }
      }).catch(err => {
        if (!this.NotNeedInfinite) {
          this.$refs.infinite.showReTry()
        }
        this.$message.error(err)
      })
    },
    reset () {
      this.tableData = []
    }
  },
  created () {
    if (!needInfiniteTypes.includes(this.configType)) {
      this.onRequestData(0)
    }
  }
}

</script>
<style lang="less">

</style>
